import { DependencyList, useEffect, useState } from 'react';

/** Custom hook to detect overflow in a given element */
const useTextOverflowDetection = (elementRef: React.RefObject<HTMLElement>, deps: DependencyList = [] ): boolean => {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);

  useEffect(() => {
    const contentElement = elementRef.current;

    if (contentElement?.scrollWidth > contentElement?.clientWidth) {
      setIsOverflowing(true);
    } else {
      setIsOverflowing(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return isOverflowing;
};

export default useTextOverflowDetection;
